module.exports = __webpack_public_path__ + "static/media/portfolio1 (64).a1bcdeeb.jpeg";